import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ContainedButton } from 'components/ContainedButton';
import { TFunction } from 'i18next';
import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  t: TFunction,
  isValid: boolean,
  openCreateProrationModal: () => void,
  disableAddProration: boolean
};

const useStyles = makeStyles((theme: any) => ({
  headerContainer: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    borderBottomColor: theme.accent.main,
    borderBottomStyle: 'solid',
    borderBottomWidth: 1,
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2),
      alignItems: 'center',
      gap: theme.spacing(1),
    },
  },
  headerTitle: {
    fontWeight: 500,
    color: theme.palette.primary.main,
    [theme.breakpoints.down('md')]: {
      fontSize: theme.typography.h6.fontSize,
    },
  },
  titleContainer: {
    minWidth: 0,
  },
  actionContainer: {
    flexShrink: 0,
  },
}));

export const Header = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Grid
      container
      justifyContent="space-between"
      className={classes.headerContainer}
    >
      <Grid item xs className={classes.titleContainer}>
        <Typography variant="h5" className={classes.headerTitle}>
          {t('accounting:disbursementsLedger')}
        </Typography>
      </Grid>

      <Grid item className={classes.actionContainer}>
        <div id="disbursements-add-entry-portal" />
      </Grid>
    </Grid>
  );
};
